import styled, { css } from 'styled-components';
import { Button, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import { Tab, TabList } from '@bechtel/gds';

export const CommodityTabList = styled(TabList)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
  border-top: 1px solid ${({ theme }) => theme.colors.grey['300']};
`;

export const CommodityTab = styled(Tab)`
  flex-grow: 1;

  &:focus {
    outline: 0;
  }
`;

interface CommodityButtonProps {
  selected?: boolean;
}

export const CommodityButton = styled(Button as React.FC<CommodityButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes['400']};
    padding-bottom: ${theme.spacings[500]};
    padding-top: ${theme.spacings[500]};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 6px;
      background-color: ${theme.colors.blue['600']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;
